import * as Styled from './styles'

export default function ButtonOrange({ children, link, type, disabled }) {
  return (
    <Styled.ButtonOrange onClick={link} type={type} disabled={disabled}>
      {children}
    </Styled.ButtonOrange>
  )
}
